import {Component, OnInit} from '@angular/core';
import {LoadingService} from '../../../../services/loading.service';
import {ErrorType} from '../../../../model/error-type';
import {Match} from '../../../../model/events/Match';
import {RestErrorHelper} from '../../../../helper/rest-error-helper';
import {FrontendService} from '../../../../services/frontend.service';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {EventHelper} from '../../event/event-helper';
import {LoadingComponent} from '../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../components/generic/message/message.component';
import {TranslateModule} from '@ngx-translate/core';
import {SpielScorerAnsichtComponent} from './spiel-scorer-ansicht/spiel-scorer-ansicht.component';

@Component({
  standalone: true,
  selector: 'app-spiel-spielverlauf',
  templateUrl: './spiel-spielverlauf.component.html',
  imports: [
    LoadingComponent,
    MessageComponent,
    TranslateModule,
    SpielScorerAnsichtComponent
  ],
  styleUrls: ['./spiel-spielverlauf.component.scss']
})
export class SpielSpielverlaufComponent implements OnInit
{
  loading = new LoadingService();
  errorMsg: ErrorType;

  match: Match;
  eventId: number;
  matchId: number;
  databaseId: number;
  statistics: any[];
  statisticsParticipants: any[];

  constructor(private restErrorHelper: RestErrorHelper,
              public config: DynamicDialogConfig,
              public frontendService: FrontendService)
  {
    console.log('constructor, config.data', config.data);
    this.eventId = config.data.eventId;
    this.databaseId = config.data.databaseId;
    this.matchId = config.data.matchId;
    this.match = config.data.match;
    if (this.match.eventId)
      this.eventId = this.match.eventId;
    if (this.match.id)
      this.matchId = this.match.id;

    console.log('eventId: ' + this.eventId + ', matchId: ' + this.matchId + ', databaseId: ' + this.databaseId);
  }

  ngOnInit(): void
  {
    this.loadData();
  }

  private loadData(): void
  {
    console.log('loadData(), match: ', this.match);
    if (!this.match?.isDartsscorer)
      return;

    this.loading.isLoading = true;
    this.errorMsg = undefined;

    this.frontendService.getMatchStatistics(this.databaseId, this.eventId, this.matchId, true).subscribe({
      next: data =>
      {
        console.log('Match-Statistiken erhalten', data);
        if (data)
        {
          this.statistics = data.statistics;
          this.statisticsParticipants = data.statisticsParticipants;
        }
        this.loading.isLoading = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.statistics = undefined;
        this.loading.isLoading = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

}
